/**
 * Import jQuery and set it as a global BEFORE any jQuery plugins load.
 * This is required because Bootstrap 4 and jQuery plugins (jquery-scroll-lock,
 * jquery.appear) expect window.jQuery to exist when they initialize.
 */
import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;
